import BaseAPI from "./apiBase";


async function saveMedicalRecord(data) {
    const result = await BaseAPI.simplePostAsync('/medicalRecord', data);

    return result;
}

async function getMedicalRecords(params) {
    const result = await BaseAPI.simpleGetAsync('/medicalRecord', { params });
    return result;
}

async function getMedicalRecordDocuments(medicalRecordID) {
    const result = await BaseAPI.simpleGetAsync("/medicalRecord/documents", { params: { medicalRecordID } });
    return result.data;
}

async function getMedicalRecordImages(medicalRecordID) {
    const result = await BaseAPI.simpleGetAsync("/medicalRecord/images", { params: { medicalRecordID } });
    return result.data;
}

async function deleteMedicalRecordImage(ImageID) {

    var result = await BaseAPI.simpleDeleteAsync("/medicalRecordImg", ImageID);
    return result;
}

async function deleteMedicalRecordReport(DocumentID) {

    var result = await BaseAPI.simpleDeleteAsync("/document/medicalRecordReport", DocumentID);
    return result;
}

async function getFollowupChanges(medicalRecordID) {
    const result = await BaseAPI.simpleGetAsync("/medicalRecord/followupChanges", { params: { medicalRecordID } });
    return result.data;
}

async function getFollowups(params) {
    const result = await BaseAPI.simpleGetAsync("/medicalRecord/followups", { params });
    return result.data;
}

async function closeFollowup(followupListID) {
    const result = await BaseAPI.simplePostAsync("/medicalRecord/closeFollowup", followupListID);
    return result;
}

export default {
    saveMedicalRecord,
    getMedicalRecords,
    getMedicalRecordDocuments,
    getMedicalRecordImages,
    getFollowupChanges,
    getFollowups,
    closeFollowup,
    deleteMedicalRecordImage,
    deleteMedicalRecordReport
}